import React, { FC } from 'react';
import styled from 'styled-components';

interface Props {
	title?: string;
	value: number;
	max?: number;
	backgroundColor?: string;
	color?: string;
	borderRadius?: number;
	fontSize?: number;
	fontColor?: string;
	fontWeight?: number;
	height?: number;
	transitionDuration?: number;
}

const ProgressBackground = styled.div<Props>`
	border-radius: ${({ borderRadius }) => borderRadius ?? 4}px;
	background-color: ${({ backgroundColor }) => backgroundColor ?? '#D9D9E0'};
	height: ${({ height }) => height ?? 10}px;
	width: 100%;
`;

const ProgressValue = styled.div<Props>`
	border-radius: ${({ borderRadius }) => borderRadius ?? 4}px;
	background: ${({ color }) => color ?? 'linear-gradient(40deg, #6467F0 27.77%, #402C86 102.67%)'};
	width: ${({ value, max }) => (value * 100) / (max ?? 100) ?? 0}%;
	height: ${({ height }) => height ?? 10}px;
	backdrop-filter: blur(4.53047px);
	transition: all ${({ transitionDuration }) => transitionDuration ?? 0.3}s ease-in-out;
`;

const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 5px;
`;

const Title = styled.div<Omit<Props, 'value'>>`
	font-weight: ${({ fontWeight }) => fontWeight ?? 500};
	font-size: ${({ fontSize }) => fontSize ?? 14}px;
	color: ${({ fontColor }) => fontColor ?? '#000000'};
	letter-spacing: -0.41px;
`;

export const Progress: FC<Props> = props => {
	const { title } = props;
	return (
		<Container>
			{title && <Title {...props}>{title}</Title>}
			<ProgressBackground {...props}>
				<ProgressValue {...props}></ProgressValue>
			</ProgressBackground>
		</Container>
	);
};
